$(function(){

    function shuffleGridItems($grid_random_container, $grid_random_items) {

        // init
        var i, index1, index2, temp_val;

        var count = $grid_random_items.length;
        var shuffled_array = [];

        // populate array of indexes
        for (i = 0; i < count; i++) {
            shuffled_array.push(i);
        }

        // shuffle indexes
        for (i = 0; i < count; i++) {
            index1 = (Math.random() * count) | 0;
            index2 = (Math.random() * count) | 0;

            temp_val = shuffled_array[index1];
            shuffled_array[index1] = shuffled_array[index2];
            shuffled_array[index2] = temp_val;
        }

        // apply random order to elements
        $grid_random_items.detach();
        for (i = 0; i < count; i++) {
            $grid_random_container.append( $grid_random_items.eq(shuffled_array[i]) );
        }
    }

    function startGridTransitions($grid_random_container, $grid_random_items) {

        // init
        var nr_of_items = $grid_random_items.length;

        // config
        var group_attr = 'data-group';
        var position_attr = 'data-position';
        var visible_class = 'visible';
        var items_per_group = 8;
        var counter = 1;
        var group_counter = 1;

        // store items for initial interval delay
        var initial_interval_delay_items = (nr_of_items-items_per_group);

        // loop settings
        var position_reveal_order = [1,8,5,7,3,4,2,6];
        var delay_between_items = 1500;

        // hide elements that are not in the first set
        $grid_random_items.each(function(i){
            // init
            var $this = $(this);
            // add group id
            $this.attr(group_attr,group_counter);
            $this.attr(position_attr,counter);
            // mark as hidden if not in first set
            if (group_counter === 1) {
                $this.addClass(visible_class);
            }
            // end of group, reset counter and increase group counter
            if (counter>=items_per_group) {
                group_counter++;
                counter = 0;
            }
            // increase counter
            counter++;
        });

        var revealItem = function($lower_item, $activate_item,delay) {
            setTimeout(function(){
                $lower_item.removeClass(visible_class);
                // set visible class on active item
                $activate_item.addClass(visible_class);
            },delay);
        }

        var layerLoop = function(initial=true) {
            // init
            var total_loop_counter = 1;
            var loop_counter = 1;
            var group_start = 1;

            // in round 1, the first group is already revealed, so we want to start with group 2
            if (initial) {
                // start revealing the second group
                group_start = 2;
                // TBD
                loop_counter = items_per_group + 1;
                // update items for interval delay
                $grid_random_container.attr('data-interval-delay-items',nr_of_items);
            }
            // loop group by group, starting with the second, as the first is already being displayed
            for (var group = group_start; group <= group_counter; group++) {
                // reveal item by item according to reveal order
                position_reveal_order.forEach( function (position, i) {
                    // try to get current item
                    var $activate_item = $grid_random_container.find('['+position_attr+'="'+position+'"]['+group_attr+'="'+group+'"]');
                    // do stuff when element exists
                    if ($activate_item.length > 0) {
                        // calculate delay
                        var delay = delay_between_items * total_loop_counter;
                        // hide items in same position below
                        var $lower_item = $grid_random_container.find('['+position_attr+'="'+position+'"]').not('['+group_attr+'="'+group+'"]');
                        // reveal items
                        revealItem($lower_item,$activate_item,delay);
                        // keep going, increase counter
                        loop_counter++;
                        total_loop_counter++;
                    }
                });
            }

        }

        // 1. start layering on page load
        layerLoop();

        // // 2. set interval for first round
        var interval = setInterval(function() {
            var initial = false;
            layerLoop(initial);
            clearInterval(interval);
        }, delay_between_items * initial_interval_delay_items);

        // // 3. set interval for any following rounds
        var timeout = delay_between_items * (items_per_group+1);
        setTimeout(function(){
            var interval = setInterval(function() {
                var initial = false;
                layerLoop(initial);
            }, delay_between_items * nr_of_items);
        },timeout);

    }

    function initGridRandom() {

        // init
        var $grid_random_container = $('.grid-random-container');
        var $grid_random_items = $grid_random_container.find('.grid-item').not('.branding');

        // no grid? hit the road...
        if ($grid_random_container.length === 0) {
            return false;
        }

        // first of all, shuffle grid
        shuffleGridItems($grid_random_container, $grid_random_items);

        // then, delayed start the transitions
        setTimeout(function(){
            // re-select the items first
            $grid_random_container = $('.grid-random-container');
            $grid_random_items = $grid_random_container.find('.grid-item').not('.branding');
            // start transitions
            startGridTransitions($grid_random_container, $grid_random_items);
        },500);

        // brain storming:

        // brand claim stays in position
        // one image changes at a time
        // working with z-index and visible classes
        // check ID of visible elements in order to prevent a person being displayed twice
        // make sure at least 1 of each data-position is visible
        // layer on top (=never a missing picture)

        // interval math
        /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        1. the first loop starts with group number 2, which means the next call of the loop function has to start delayed after 'nr_of_items(18)-items_per_group(8)=10'

        */

    }

    // on page load
    initGridRandom();

    $(window).on('initGridRandom',function(){
        initGridRandom();
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/grid-random.js